import React, { useRef, useEffect } from 'react';
import { Helmet } from 'react-helmet';

const TrustpilotWidget = ({ type }) => {
  const widget = useRef(null);

  useEffect(() => {
    if (typeof window !== 'undefined' && window.Trustpilot) {
      window.Trustpilot.loadFromElement(widget.current, true);
    }
  }, []);

  return (
    <>
      <Helmet>
        <script
          type="text/javascript"
          src="//widget.trustpilot.com/bootstrap/v5/tp.widget.bootstrap.min.js"
          async
        ></script>
      </Helmet>
      {type === 'carousel' ? (
        <div
          ref={widget}
          class="trustpilot-widget"
          data-locale="en-GB"
          data-template-id="53aa8912dec7e10d38f59f36"
          data-businessunit-id="48e90ed4000064000503c4e8"
          data-style-height="140px"
          data-style-width="100%"
          data-theme="light"
          data-stars="1,2,3,4,5"
          data-review-languages="en"
        >
          <a
            href="https://uk.trustpilot.com/review/www.displaywizard.co.uk"
            target="_blank"
            rel="noopener"
          >
            Trustpilot
          </a>
        </div>
      ) : type === 'grid' ? (
        <div
          ref={widget}
          class="trustpilot-widget"
          data-locale="en-GB"
          data-template-id="539adbd6dec7e10e686debee"
          data-businessunit-id="48e90ed4000064000503c4e8"
          data-style-height="800px"
          data-style-width="100%"
          data-theme="light"
          data-stars="1,2,3,4,5"
          data-review-languages="en"
        >
          <a
            href="https://uk.trustpilot.com/review/www.displaywizard.co.uk"
            target="_blank"
            rel="noopener"
          >
            Trustpilot
          </a>
        </div>
      ) : (
        ''
      )}
    </>
  );
};

export default TrustpilotWidget;
